import PropTypes from 'prop-types';
export var buttonTypePropType = PropTypes.oneOf(['button', 'reset', 'submit']);
//# sourceMappingURL=consts.js.map